import React, {Component} from 'react';

//styled-components
import {MaxWidthContainer} from './styles';

class MaxWidthContainerComp extends Component {
  render() {
    const {children} = this.props;
    return <MaxWidthContainer>{children}</MaxWidthContainer>;
  }
}

export default MaxWidthContainerComp;
